import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import api from '../middleware/api'
import rootReducer from '../reducers'
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import {
  createResponsiveStoreEnhancer
} from 'redux-responsive'

const configureStore = preloadedState => {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(
      createResponsiveStoreEnhancer({createInitially: false}),
      applyMiddleware(routerMiddleware(browserHistory), thunk, api, createLogger())
    )
  )

  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/store/configureStore.production.js